export enum clickEventEnum {
    primary = "primary",
    secondary = "secondary",
}

export enum dialogTypeEnum {
    delete = "delete",
    pause = "pause",
    merge = "merge"
}

export enum campaignStatusEnum {
    archived = "ARCHIVED",
    underNurturing = "UNDER_NURTURING",
    nurturing = "NURTURING",
    paused = "PAUSED"
}

export enum mergeCampaignEnum {
    createCampaign = "create_campaign"
}
